import React from "react";
import { useTranslation } from "react-i18next";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import MenuWidget from "../Widget/MenuWidget";
import SocialWidget from "../Widget/SocialWidget";
import TextWidget from "../Widget/TextWidget";

export default function Footer() {
  const { t } = useTranslation();

  const menuDataOne = [
    { title: t("nav.nav_home"), href: "/" },
    { title: t("nav.nav_about"), href: "/about" },
    { title: t("nav.nav_services"), href: "/services" },
  ];

  const menuDataTwo = [
    { title: t("nav.nav_blog"), href: "/blog" },
    { title: t("nav.nav_pharmacovigilance"), href: "/pharmacovigilance" },
    { title: t("nav.nav_contact"), href: "/contact" },
  ];

  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: "url(/images/footer_bg_1.svg)" }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: "url(/images/footer_logo_bg.svg)" }}
        >
          <img
            src="/images/icon-1.svg"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
            style={{ width: "80px" }}
          />
          <h2 className="cs_footer_brand_text">Incomed</h2>
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text={t("footer.description")} />
                <div className="cs_height_30" />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataTwo} />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item">
                <ContactInfoWidget />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <div className="cs_copyright">{t("footer.copyright").replace("2025", new Date().getFullYear())}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
